import { render, staticRenderFns } from "./BdrTableBSZ.vue?vue&type=template&id=6d2944bc&scoped=true&"
import script from "./BdrTableBSZ.vue?vue&type=script&lang=js&"
export * from "./BdrTableBSZ.vue?vue&type=script&lang=js&"
import style0 from "./BdrTableBSZ.vue?vue&type=style&index=0&id=6d2944bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2944bc",
  null
  
)

export default component.exports